(() => {
  const normalize = (value) => value
    .toLocaleLowerCase(document.documentElement.lang || undefined)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const initialize = (root) => {
    if (root.dataset.lcFaqReady === 'true') return;
    root.dataset.lcFaqReady = 'true';

    const items = [...root.querySelectorAll('[data-lc-faq-item]')];
    const categories = [...root.querySelectorAll('[data-lc-faq-category]')];
    const filters = [...root.querySelectorAll('[data-lc-faq-filter]')];
    const search = root.querySelector('[data-lc-faq-search]');
    const empty = root.querySelector('[data-lc-faq-empty]');
    const status = root.querySelector('[data-lc-faq-status]');
    let activeCategory = 'all';

    if (search) {
      const placeholder = search.dataset.lcFaqPlaceholder || search.placeholder;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let typingTimer;

      const stopTyping = () => {
        window.clearTimeout(typingTimer);
        search.placeholder = placeholder;
      };

      const typePlaceholder = () => {
        window.clearTimeout(typingTimer);

        if (reducedMotion || search.value || document.activeElement === search) {
          search.placeholder = placeholder;
          return;
        }

        let characterIndex = 0;
        search.placeholder = '';

        const typeNextCharacter = () => {
          if (search.value || document.activeElement === search) {
            stopTyping();
            return;
          }

          characterIndex += 1;
          search.placeholder = placeholder.slice(0, characterIndex);

          if (characterIndex < placeholder.length) {
            typingTimer = window.setTimeout(typeNextCharacter, 54);
          }
        };

        typingTimer = window.setTimeout(typeNextCharacter, 320);
      };

      search.addEventListener('focus', stopTyping);
      search.addEventListener('blur', () => {
        if (!search.value) typePlaceholder();
      });
      typePlaceholder();
    }

    const update = () => {
      const query = normalize(search?.value || '');
      let visibleCount = 0;

      items.forEach((item) => {
        const matchesCategory = activeCategory === 'all' || item.dataset.faqCategory === activeCategory;
        const matchesSearch = !query || normalize(item.textContent).includes(query);
        const visible = matchesCategory && matchesSearch;
        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) visibleCount += 1;
      });

      const expandMatchingCategories = Boolean(query) || activeCategory !== 'all';
      categories.forEach((category) => {
        const hasVisibleItems = Boolean(category.querySelector('[data-lc-faq-item]:not([hidden])'));
        category.hidden = !hasVisibleItems;
        if (expandMatchingCategories) category.open = hasVisibleItems;
      });

      if (empty) empty.hidden = visibleCount !== 0;
      if (status) {
        const template = visibleCount === 1 ? status.dataset.one : status.dataset.other;
        status.textContent = template.replace('[count]', visibleCount);
      }
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.lcFaqFilter;
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
        if (activeCategory === 'all' && !search?.value) {
          categories.forEach((category) => { category.open = false; });
        }
        update();
      });
    });

    search?.addEventListener('input', () => {
      if (!search.value && activeCategory === 'all') {
        categories.forEach((category) => { category.open = false; });
      }
      update();
    });

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const hashHandle = decodeURIComponent(window.location.hash.slice(1));
    if (hashHandle) {
      const linkedItem = items.find((item) => item.dataset.faqHandle === hashHandle);
      if (linkedItem) linkedItem.open = true;
    }

    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-lc-faq-master]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
